const snackbar = (tokens) => {
    return {
        MuiSnackbar: {
            defaultProps: {
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            },
            styleOverrides: {
                root: {
                    "& .MuiPaper-root": {
                        width: tokens.component.toast.width.value,
                    },
                },
            },
        },
    };
};
export default snackbar;
//# sourceMappingURL=snackbar.js.map